import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class LeaseTermDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leaseTermDetails: this.props.leaseTermDetails,
      renewalTerms: this.props.renewalTerms,
    };
  }

  render() {
    return (
      <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
        <div className="row tabForm">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Document
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.leaseTermDetails.leaseDocument}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                        LOI Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {leaseDateFormat(this.state.leaseTermDetails.invoiceSingingDate)}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Creation Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.leaseCreationDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.leaseCreationDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Document Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.leaseDocumentDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.leaseDocumentDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Registration Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.leaseRegistrationDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.leaseRegistrationDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Fitout Letter Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.fitoutLetterDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.fitoutLetterDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Fitout Start Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.fitoutStartDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.fitoutStartDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Fitout Period (Days)
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.leaseTermDetails.fitoutPeriod}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit Possession Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.leaseTermDetails.unitPossessionDate != "" &&
                      this.state.leaseTermDetails.unitPossessionDate !=
                        "0000-00-00"
                        ? //dateFormat(
                          //     this.state.leaseTermDetails.unitPossessionDate,
                          //     "dd mmm yyyy"
                          //   )
                          leaseDateFormat(
                            this.state.leaseTermDetails.unitPossessionDate
                          )
                        : "00-00-0000"}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Fitout End Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.fitoutEndDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.fitoutEndDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Commencement Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.leaseCommencementDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.leaseCommencementDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              {
                this.state.leaseTermDetails.rentCommencementDate != "0000-00-00" && (
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Renewal Commencement Date
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {/* {dateFormat(
                            this.state.leaseTermDetails.leaseCommencementDate,
                            "dd mmm yyyy"
                          )} */}
                          {leaseDateFormat(
                            this.state.leaseTermDetails.renewalCommencementDate
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                ) 
              }
              
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Rent Free Period (Days) (Operational) (MM-DD)
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.leaseTermDetails.rentFreePeriodMonths == ""
                        ? "0"
                        : this.state.leaseTermDetails.rentFreePeriodMonths}
                      {" - "}
                      {this.state.leaseTermDetails.rentFreePeriodDays == ""
                        ? "0"
                        : this.state.leaseTermDetails.rentFreePeriodDays}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Rent Commencement Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.rentCommencementDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.rentCommencementDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Term (YY-MM-DD)
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.leaseTermDetails.leaseTermYY}
                      {`-`}
                      {this.state.leaseTermDetails.leaseTermMM}
                      {`-`}
                      {this.state.leaseTermDetails.leaseTermDD}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Expiry Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.leaseExpiryDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.leaseExpiryDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lease Dead End Date
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {/* {dateFormat(
                        this.state.leaseTermDetails.leaseDeadEndDate,
                        "dd mmm yyyy"
                      )} */}
                      {leaseDateFormat(
                        this.state.leaseTermDetails.leaseDeadEndDate
                      )}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {this.state.renewalTerms.map(function (name, index) {
              return (
                <div className="row">
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          {`Renewal Term(s) ${index + 1} (YY-MM-DD)`}
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.year}
                          {`-`}
                          {name.month}
                          {`-`}
                          {name.date}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          {`Renewal ${
                            index + 1
                          } Notice Due Before Expiry (in Months)`}
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.renewalNoticeDueDate}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }, this)}
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Renewal Period Commercial Input
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.leaseTermDetails.renewalPeriodCommercialInput}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Notes
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.leaseTermNotes}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LeaseTermDetails);
